<template>
    <router-link :to="`/chat/${userId}`">
        <div class="card-panel row">
        <div class="col s2 l1 xl1 m1">
            <CardAvatar 
                v-if="avatar!==undefined" 
                :userId="userId"
                :avatar="avatar" 
                :OPTIONS="{showOnlineStatus:true}"
            />
        </div>
        <div class="col s10 l11 xl11 m11">
            <strong>{{getAuthId === dialogue.from ? "Вы написали: " : ""}}</strong>
            {{dialogue.text}}
        </div>

        </div>
    </router-link>
</template>

<script>
import CardAvatar from '@/components/basic/CardAvatar.vue'
import { mapGetters } from 'vuex'

export default {
    components: { CardAvatar },
    data(){
        return {
            userId: undefined,
            avatar: undefined
        }
    },
    props: {
        dialogue: {
            type: Object,
            default: function(){
                return {}
            }
        }
    },
    computed:{
        ...mapGetters(['getAuthId']),
    },
    methods:{
        dialogueWith(dialogue){
            return this.getAuthId === dialogue.from ? dialogue.to : dialogue.from
        }
    },
    async created(){
       this.userId = this.dialogueWith(this.dialogue)
       this.avatar = ((await this.$axios.get(`/get_user_simple/${this.userId}`)).data).avatar
    }
}
</script>